import React from "react";
import HLine from "../../components/components/hline";
import {
  Description,
  Heading,
  Parapgraph,
} from "../../components/components/text";

export default function Downloads() {
  return (
    <>
      <HLine />
      <Heading>Download</Heading>
      <HLine />
      <Parapgraph>
        In order to play, you need to download our client. There is no setup
        file, just extract the folder and run TibiaSwap.exe to launch the game.{" "}
        <br />
        Download TibiaSwap client for windows <a href="#">HERE</a>.
      </Parapgraph>
    </>
  );
}
